import React from 'react';
import './SubPages.css';
import HomeButton from './HomeButton';
import Footer from './Footer';

const ContactPage = () => (
  <div className="subpage-container">
    <HomeButton />
    <h1>Get in Touch</h1>
    <div className="subpage-content">
      <p>Have questions or feedback? We'd love to hear from you.</p>
      <form className="contact-form">
        <input type="text" placeholder="Your Name" required />
        <input type="email" placeholder="Your Email" required />
        <textarea rows="5" placeholder="How can we help?" required></textarea>
        <button type="submit" className="cta-button">Send Message</button>
      </form>
    </div>
                <div className="footer-wrapper">
                <Footer />
            </div>
  </div>
);

export default ContactPage;